



















import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation } from 'vuex-class';
import { MutationTypes } from '@/modules/cms/store/mutations'

/**
 * Vista previa de la publicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class PagePreview extends Vue {
    @State(state => state.cms.pagePreviewContent)
    public previewContent: string

    @State(state => state.cms.loadingPagePreview)
    public loading: boolean

    @Mutation(`cms/${MutationTypes.TogglePagePreview}`)
    public togglePreview: (boolean: false) => void

    /**
     * Comprueba si la vista previa se encuentra activa
     *
     * @returns { boolean }
     */
    get active () {
        const isActive = this.$store.state.cms.pagePreview

        // Oculta la barra de scroll (si existe) del elemento principal, para que
        // no se muestren dos barras (junto con la del iframe)
        const style = isActive ? 'hidden' : 'auto'
        document.getElementsByTagName('html')[0].style.overflow = style

        return isActive
    }
}
